// Timer constants — centralise delay values so they're easy to tune.
export const MODAL_CLOSE_DELAY_MS = 1400; // pause after success animation before dismissing modal
export const TOAST_DURATION_MS    = 2000; // inline "saved" / "updated" feedback display duration

// Maps entry status → short badge key used in CSS classes and export HTML.
// Cancelled entries use "CANCELLED" regardless of .status value.
export const STATUS_EXPORT_KEY = {
  "PARTIAL SUCCESS":       "PARTIAL",
  "UNABLE TO CONFIRM":     "UNABLE",
  "PROTECTED":             "PROTECTED",
};

// Statuses a UA user can select on a card. A blank status shows no badge.
// Monitoring is not a status — it's the separate `monitoring` flag (tracked in TDT).
export const STATUS_OPTIONS = ["SUCCESS", "PARTIAL SUCCESS", "UNSUCCESSFUL", "REBOOKED", "PROTECTED", "UNABLE TO CONFIRM"];

// What happened to a named passenger who didn't make the connection, recorded by hand
// (TDT can't say which passengers failed). Only offered on these statuses.
export const PAX_OUTCOMES = ["REBOOKED", "OVERNIGHT", "NO-SHOW", "REFUND", "OTHER"];
export const PAX_OUTCOME_STATUSES = new Set(["PARTIAL SUCCESS", "UNSUCCESSFUL"]);
// Connection cards are kept for today plus the two days before (older ones are purged on login).
export const CARD_HISTORY_DAYS = 3;

// A card stays in the Open list until it has a completing status.
export const isOpenStatus = (status) => !status || status === "PROTECTED";

// TDT outcome remarks — same wording the TDT sync writes
export const OUTCOME_REMARKS = {
  "SUCCESS":         "Successful connection automatically detected via TDT tool",
  "PARTIAL SUCCESS": "Partial Success connection automatically detected via TDT tool",
  "UNSUCCESSFUL":    "Unsuccessful connection automatically detected via TDT tool",
};

// TDT-detected outcome waiting for a UA SCCO to approve or reject. Only counts while
// the card is still open — once a real status is set, the suggestion is moot.
export const isPendingReview = (e) => !!e.pendingStatus && isOpenStatus(e.status);

// Which list tab a card belongs to: "open" | "pending" | "complete".
export const completionTab = (e) =>
  !isOpenStatus(e.status) ? "complete" : isPendingReview(e) ? "pending" : "open";
